// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"005bdc4a447e4d904402","339":"1851b3c74a4fa0cf65d5"}[chunkId] + ".js";
};